import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/game/:gameId',
    name: 'Game',
    component: () => import('../components/tabs/Game.vue')
  },
  {
    path: '/feed/:gameId/:projectId/:teamId',
    name: 'Feed',
    component: () => import('../components/tabs/Feed.vue')
  },
  {
    path: '/fanzone/:gameId',
    name: 'Fanzone',
    component: () => import('../components/tabs/Fanzone.vue')
  },
  {
    path: '/fanguide/:gameId',
    name: 'Skarb kibica',
    component: () => import('../components/tabs/FansGuide.vue')
  },
  {
    path: '/event/:eventId',
    name: 'Event',
    component: () => import('../components/tabs/Event.vue')
  },
  {
    path: '/event/feed/:eventId',
    name: 'EventFeed',
    component: () => import('../components/tabs/EventFeed.vue')
  },
  {
    path: '/event/fanzone/:eventId',
    name: 'EventFanzone',
    component: () => import('../components/tabs/EventFanzone.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
